import { toast } from "react-toastify"
import { api } from "../../Lib/constants"
import { ADD_DESIGNATION, ADD_DESIGNATION_FAILED, ADD_DESIGNATION_SUCCESS, DESIGNATION, DESIGNATION_FAILED, DESIGNATION_SUCCESS, UPDATE_DESIGNATION, UPDATE_DESIGNATION_FAILED, UPDATE_DESIGNATION_SUCCESS } from "./actionTypes"
import { getAuthHeader } from "../../Lib/utils"
import { getDepartments } from "../Department/action"

export const getDesignations = () => async (dispatch) => {
  dispatch({
    type: DESIGNATION,
  });
  try {
    let response = await api(`designation/designationList`, "get", {}, getAuthHeader());
    dispatch({
      type: DESIGNATION_SUCCESS,
      payload: response?.data,
    });
    return response;
  } catch (error) {
    console.log("while fetching Designation list error ====>", error);
    return dispatch({
      type: DESIGNATION_FAILED,
      payload: error?.message,
    });
  }
};

export const addDesignation = (data) => async dispatch => {
  dispatch({
    type: ADD_DESIGNATION
  })
  try {
    let response = await api(`designation/add`, 'post', data, getAuthHeader())
    console.log('add designation data', response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_DESIGNATION_SUCCESS,
      payload: response?.data
    })
    await dispatch(getDepartments());
    await dispatch(getDesignations());
    return response
  } catch (error) {
    console.log("while Adding designation error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_DESIGNATION_FAILED,
      payload: error?.message
    })
  }
}

export const updateDesignation = (id, data) => async dispatch => {
  dispatch({
    type: UPDATE_DESIGNATION
  })
  try {
    let response = await api(`designation/update/${id}`, 'put', data, getAuthHeader())
    console.log('update designation data', response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_DESIGNATION_SUCCESS,
      payload: response?.data
    })
    await dispatch(getDepartments());
    await dispatch(getDesignations());
    return response
  } catch (error) {
    console.log("while updating designation error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_DESIGNATION_FAILED,
      payload: error?.message
    })
  }
}
